export default __webpack_public_path__ + "static/media/close.de4d0db2.svg";